import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { Dropdown, DropdownItem, DropdownMenu } from 'components/Dropdown2';
import Message from 'components/Message';
import { PFE_ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';

import messages from '../ModifierLibrary.messages';

const { element } = bem('modifier-library');

const RowActionsDropdown = ({ ariaLabel, onEdit, onDuplicate, onDelete }) => (
  <Dropdown attachment="right" className={element('actions')} contentClassName={element('actions-menu')}>
    {({ toggleMenu, closeMenu }) => (
      <>
        <button type="button" className={element('actions-button')} aria-label={ariaLabel} onClick={toggleMenu}>
          <Isvg src={PFE_ICONS.threeDots} />
        </button>
        <DropdownMenu>
          <DropdownItem
            onClick={() => {
              closeMenu();
              onEdit();
            }}>
            <Message message={messages.edit} />
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              closeMenu();
              onDuplicate();
            }}>
            <Message message={messages.duplicate} />
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              closeMenu();
              onDelete();
            }}>
            <Message message={messages.delete} />
          </DropdownItem>
        </DropdownMenu>
      </>
    )}
  </Dropdown>
);

RowActionsDropdown.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default RowActionsDropdown;
